import axios from 'axios';
import BaseService from './baseService';

const baseService = new BaseService();

export interface HealthcheckResponse {
  status: string;
}

class HealthcheckService {
  public async checkHealth(): Promise<HealthcheckResponse> {
    try {
      // Faz uma requisição simples para verificar se a API está respondendo
      // Usamos um endpoint que sabemos que existe
      await axios.get(`${baseService.getApiUrl()}/auth/signin`, { 
        timeout: 5000,
        validateStatus: (status) => status < 500 // Aceita qualquer status < 500 (incluindo 401, 404, etc)
      });
      
      return { status: 'API está respondendo' };
    } catch (error: any) {
      if (error.code === 'ECONNABORTED') {
        throw new Error('Timeout: API não está respondendo');
      }
      if (error.response) {
        // Se recebemos uma resposta (mesmo que seja erro), significa que a API está funcionando
        return { status: `API está respondendo (Status: ${error.response.status})` };
      }
      throw new Error('API não está acessível');
    }
  }
}

export default new HealthcheckService(); 